// extracted by mini-css-extract-plugin
module.exports = {"icon":"_RadioGroup_icon_goZdb"};